import { useContext, useEffect, useState } from 'react'
import { ReactComponent as Back } from 'assets/transport/drawer/back.svg'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { GlobalContext } from 'App'
import { jsonAxios } from 'components/axios'
import { IAS } from 'types/as'
import { ReactComponent as AllDown } from 'assets/mypage/allDown.svg'
import CustomButton from 'components/common/CustomButton'
import { download } from 'components/function'
import { ReactComponent as FileList } from 'assets/common/fileList.svg'

interface IAsDrawer {
    isOpen: boolean
    toggleDrawer: () => void
    id?: number
}

const AsDrawer = ({ isOpen, toggleDrawer, id }: IAsDrawer) => {
    const { isTablet } = useContext(GlobalContext);
    const [data, setData] = useState<IAS>({} as IAS)

    useEffect(() => {
        if (isOpen && id) {
            jsonAxios.get(`user/warehouse/${id}`).then(res => {
                console.log(res.data)
                if (res.data.code === 200) {
                    setData(res.data.data)
                }
            })
        }
    }, [isOpen, id])


    return (
        <Drawer
            open={isOpen}
            onClose={() => {
                toggleDrawer();
            }}
            direction='left'
            lockBackgroundScroll
            size={isTablet ? '100%' : `750px`}
        >
            <div className='flex flex-col gap-6 p-10 tablet:p-4 h-full overflow-y-auto'>
                <div className='flex justify-between items-center'>
                    <p className='font-semibold text-2xl'>사후관리</p>
                    <Back onClick={toggleDrawer} />
                </div>

                <div className='flex flex-col px-6 py-3 border border-[#D7D8E6] rounded'>
                    <div className='font-semibold'>{data.title}</div>
                    <p className='text-[#9D9EB7] text-xs'>생성시간 {data.createAt}</p>
                </div>

                <div className='flex flex-col gap-5 px-6 py-3 border border-[#D7D8E6] rounded max-h-45 overflow-y-auto'>
                    <div className='flex justify-between items-center'>
                        <div>
                            <p className='font-semibold'>첨부파일 목록</p>
                            <p className='text-[#9D9EB7] text-xs'>전체 첨부파일 목록 확인 및 다운로드가 가능합니다</p>
                        </div>
                        <div>
                            <CustomButton
                                className='bg-primary !min-w-30 !h-10 !text-sm'
                                title='전체다운'
                                Icon={AllDown}
                            />
                        </div>
                    </div>
                    <div className='flex flex-col gap-2'>
                        {
                            data?.fileList?.map((item, idx) => (
                                <div
                                    className='relative flex items-center gap-3 px-6 border border-primary rounded min-w-[600px] h-10 min-h-10 text-primary text-sm cursor-pointer'
                                    onClick={() => download(item.filePath)}
                                    key={idx}>
                                    <FileList />
                                    {item.fileName}
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className='flex-[3] px-6 py-3 border border-[#D7D8E6] rounded'>
                    <p className='font-semibold'>비고 내용</p>
                    <p className='text-[#9D9EB7] text-xs'>해당 창고관리에 대한 상세 정보</p>
                    {data.content}
                </div>
            </div>
        </Drawer>
    )
}

export default AsDrawer;